import {Component, OnInit} from '@angular/core';
import {Pledge} from '../../../../services/api.client';
import {PledgeType} from '../../../../services/api.client';
import {Client} from '../../../../services/api.client';
import {PledgeStatusType} from '../../../../services/api.client';
import {splitCamelCase} from '../../../../utilities/Util';
import {PledgeTypeService} from '../../../../services/PledgeTypeService';
import {PledgeService} from '../../../../services/PledgeService';
import {ClientService} from '../../../../services/ClientService';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';

@Component({
    selector: 'ClientAssistanceComponent',
    templateUrl: './ClientAssistanceComponent.html',
    styleUrls: ['./ClientAssistanceComponent.scss'],
    standalone: false
})

export class ClientAssistanceComponent implements OnInit {

  // subscription
  currentClient: Client;
  currentClient$: Observable<Client>;
  allPledgeTypes: PledgeType[];
  allPledgeTypes$: Observable<PledgeType[]>;
  currentClientPledgeList: Pledge[];
  currentClientPledgeList$: Observable<Pledge[]>;

  constructor(private _router: Router,
              private _pledgeTypeService: PledgeTypeService,
              private _clientService: ClientService,
              private _pledgeService: PledgeService) {
    this.currentClient$ = this._clientService.currentClient$;
    this.allPledgeTypes$ = this._pledgeTypeService.allPledgeTypes$;
    this.currentClientPledgeList$ = this._pledgeService.currentClientPledgeList$;
  }

  ngOnInit(): void {
    this.currentClient$.subscribe(currentClient => this.currentClient = currentClient);
    this.allPledgeTypes$.subscribe(allPledgeTypes => this.allPledgeTypes = allPledgeTypes);
    this.currentClientPledgeList$.subscribe(currentClientPledgeList => this.currentClientPledgeList = currentClientPledgeList);
    this.getPledgeTypes();
  }

  formatPledgeTypeName(pledgeTypeId): string {

    if (!this.allPledgeTypes) {
      return '';
    }
    const type = this.allPledgeTypes.find(pledgeType => pledgeType.id === pledgeTypeId);
    // if (type && type.name) {
    // return type.name;
    // }
    return type && type.name || '';
  }

  formatPledgeStatus(pledgeStatus): string {
      if (typeof pledgeStatus === 'number' && !!PledgeStatusType[pledgeStatus]) {
          return splitCamelCase(PledgeStatusType[pledgeStatus], true);
      }
      if (typeof pledgeStatus === 'string') {
          return splitCamelCase(pledgeStatus, true);
      }
      return '';
  }

  getPledgeTypes(): void {
    this._pledgeTypeService.getAllPledgeTypes();
  }

  isClientValid(): number {
    return (this.currentClient.birthYear &&
        this.currentClient.gender &&
        this.currentClient.employmentStatus &&
        this.currentClient.houseHoldIncome && this.currentClient.houseHoldSize);
  }
}
